export interface LegalSection {
  title: string;
  paragraphs: string[];
}

export const privacySections: LegalSection[] = [
  {
    title: "Introduction",
    paragraphs: [
      "This Privacy Policy explains how AstroJal Technology (\"we\", \"us\" or \"our\") collects, uses, stores and protects information when you visit our website or use our services. We are committed to protecting your privacy and handling your personal information responsibly and transparently.",
      "By accessing our website or engaging our services, you agree to the practices described in this policy. Please read it carefully and contact us if you have any questions.",
    ],
  },
  {
    title: "Information We Collect",
    paragraphs: [
      "We collect information you provide directly to us, such as your name, email address, phone number, company name and project details when you contact us, submit an inquiry or use our services.",
      "We also collect limited technical information automatically when you visit our website, including your IP address, browser type, device information and pages you visit. This helps us understand how our site is used and improve your experience.",
    ],
  },
  {
    title: "How We Use Information",
    paragraphs: [
      "We use the information we collect to respond to your inquiries, provide and improve our services, communicate with you about projects, send relevant updates you have requested, and ensure the security and reliability of our website and services.",
      "We do not sell your personal information to third parties. We only share information with service providers who help us operate our business, and only to the extent necessary to provide services to you.",
    ],
  },
  {
    title: "Cookies",
    paragraphs: [
      "Our website uses cookies and similar technologies to remember your preferences, understand how you interact with our site and improve performance. Cookies help us deliver a more personal and efficient experience.",
      "You can control or disable cookies through your browser settings. Please note that some features of our website may not function properly if cookies are disabled.",
    ],
  },
  {
    title: "Data Security",
    paragraphs: [
      "We take reasonable and appropriate technical and organisational measures to protect your personal information against unauthorised access, loss, alteration or disclosure. Access to personal information is restricted to those who need it to perform their duties.",
      "While we strive to protect your information, no method of transmission or storage is completely secure. We encourage you to use strong passwords and take precautions when sharing personal information online.",
    ],
  },
  {
    title: "Third-party Services",
    paragraphs: [
      "Our website and services may integrate with or link to third-party services, such as payment providers, analytics tools, cloud platforms and productivity applications. These third parties have their own privacy policies, and we encourage you to review them.",
      "We are not responsible for the privacy practices of third-party websites or services. When you use them, their terms and policies apply.",
    ],
  },
  {
    title: "Data Retention",
    paragraphs: [
      "We retain personal information only for as long as necessary to fulfil the purposes for which it was collected, to comply with legal obligations, resolve disputes and enforce our agreements.",
      "When information is no longer required, we take steps to securely delete or anonymise it.",
    ],
  },
  {
    title: "User Rights",
    paragraphs: [
      "Depending on your jurisdiction, you may have rights to access, correct, update or delete your personal information, and to object to or restrict certain processing. You may also have the right to data portability.",
      "To exercise any of these rights, please contact us using the details below. We will respond to legitimate requests within a reasonable timeframe and in accordance with applicable law.",
    ],
  },
  {
    title: "Contact Information",
    paragraphs: [
      "If you have any questions or concerns about this Privacy Policy or our handling of your personal information, please contact us by email at info@astrojal.com or by phone at 099985 62168.",
    ],
  },
];

export const termsSections: LegalSection[] = [
  {
    title: "Acceptance of Terms",
    paragraphs: [
      "By accessing the AstroJal Technology website or engaging our services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you should not use our website or services.",
      "These terms apply to all visitors, users and clients of AstroJal Technology. We may update these terms from time to time, and the latest version will always be posted on this page.",
    ],
  },
  {
    title: "Services",
    paragraphs: [
      "AstroJal Technology provides software development and related technology services, including web and mobile application development, API and SaaS development, cloud infrastructure and AI integration.",
      "Specific services, deliverables, timelines and fees will be agreed in a separate proposal or contract. Unless otherwise agreed, we deliver services on a project basis with defined milestones.",
    ],
  },
  {
    title: "Payments",
    paragraphs: [
      "Payment terms are defined in each project proposal or contract. Unless otherwise agreed, projects are typically billed on a milestone or monthly basis, with an initial deposit required to begin work.",
      "Failure to make agreed payments may result in a pause or termination of services. Fees do not include applicable taxes, which are the client's responsibility unless stated otherwise.",
    ],
  },
  {
    title: "Intellectual Property",
    paragraphs: [
      "Upon full payment, ownership of the custom code and deliverables created specifically for your project is transferred to you, unless otherwise agreed in writing. This does not include our pre-existing tools, libraries and internal methodologies, which remain our intellectual property.",
      "We grant you a licence to use any third-party software or libraries incorporated into your project, subject to their respective licences.",
    ],
  },
  {
    title: "Confidentiality",
    paragraphs: [
      "Both parties agree to keep confidential any non-public information disclosed during a project, including business plans, source code, data and technical specifications. This obligation survives the completion or termination of any engagement.",
      "Confidential information may be disclosed only to those who need it to perform the work and who are bound by confidentiality obligations.",
    ],
  },
  {
    title: "User Responsibilities",
    paragraphs: [
      "You agree to provide accurate and timely information, cooperate with our team, and review and approve deliverables within agreed timeframes. Delays in providing required inputs may affect project timelines.",
      "You are responsible for the content, data and third-party integrations you provide, and for ensuring you have the rights to use them.",
    ],
  },
  {
    title: "Limitation of Liability",
    paragraphs: [
      "To the maximum extent permitted by law, AstroJal Technology shall not be liable for any indirect, incidental, special or consequential damages, or for any loss of profits, revenue, data or goodwill arising out of or related to our services.",
      "Our total liability for any claim arising out of or relating to our services shall not exceed the amount paid by you for the services giving rise to the claim.",
    ],
  },
  {
    title: "Termination",
    paragraphs: [
      "Either party may terminate a project engagement in accordance with the terms of the applicable contract. Upon termination, you are responsible for payment for work completed and expenses incurred up to the date of termination.",
      "We may suspend or terminate access to our website if you violate these terms or applicable law.",
    ],
  },
  {
    title: "Governing Law",
    paragraphs: [
      "These Terms and Conditions are governed by and construed in accordance with the laws of the Republic of India, without regard to its conflict of laws principles.",
      "Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts located in Ahmedabad, Gujarat, India.",
    ],
  },
  {
    title: "Contact Information",
    paragraphs: [
      "If you have any questions about these Terms and Conditions, please contact us by email at info@astrojal.com or by phone at 099985 62168.",
    ],
  },
];